import React from 'react';
import { TeamModal } from './TeamModal';
import { Team, TeamData } from '../../types';

interface EditTeamModalProps {
  opened: boolean;
  onClose: () => void;
  onSubmit: (teamData: TeamData) => void;
  loading?: boolean;
  team?: Team;
}

export const EditTeamModal: React.FC<EditTeamModalProps> = ({
  opened,
  onClose,
  onSubmit,
  loading = false,
  team,
}) => {
  const handleSubmit = (teamData: TeamData) => {
    // Убеждаемся, что id присутствует для редактирования
    if (teamData._id) {
      onSubmit(teamData);
    }
  };

  return (
    <TeamModal
      opened={opened}
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={loading}
      team={team}
    />
  );
};
